<template>
  <div class="nickname-card">
    <!-- Dekorasi pojok -->
    <div class="deco deco--tl" aria-hidden="true">
      <svg viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="40" cy="40" r="70" fill="#4489C6" opacity="0.10"/>
        <circle cx="10" cy="10" r="28" fill="#6DD5FA" opacity="0.15"/>
      </svg>
    </div>
    <div class="deco deco--br" aria-hidden="true">
      <svg viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="120" cy="120" r="65" fill="#F0D25B" opacity="0.13"/>
        <circle cx="148" cy="148" r="28" fill="#DF654D" opacity="0.10"/>
      </svg>
    </div>

    <div class="card-content">
      <!-- Avatar / Ikon -->
      <div class="abby-header">
        <div class="abby-mascot">
          <!-- Ganti SVG dengan gambar -->
            <img src="@/assets/pcu/2026/abby-smile-half.png" alt="Abby Mascot" class="abby-img"/>
        </div>
      </div>

      <div class="abby-dialog">
        <!-- Sapaan hangat -->
        <h2 class="greeting-title">
          Hai, <span class="highlight-name">{{ fullName }}</span>!
        </h2>

        <p class="greeting-subtitle">
          Senang bertemu denganmu! 🌟<br/>
          Sebelum kita mulai petualangan ini, boleh kami tahu
          <strong>nama panggilan</strong> kamu?
        </p>

        <!-- <p class="greeting-hint">
          Supaya perjalanan ini terasa lebih personal,<br/>
          kami akan menyapamu dengan nama panggilan pilihanmu. 😊
        </p> -->
      </div>

      <!-- Input Nickname -->
      <div class="input-group" :class="{ 'has-error': errorMsg }">
        <div class="input-wrapper" :class="{ 'has-error': errorMsg }">
          <span class="input-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/>
            </svg>
          </span>
          <input
            ref="inputRef"
            v-model.trim="localNickname"
            type="text"
            placeholder="Nama panggilan kamu..."
            maxlength="30"
            @keyup.enter="handleSubmit"
            autocomplete="off"
          />
        </div>
        <p v-if="errorMsg" class="error-message">{{ errorMsg }}</p>
      </div>

      <!-- Tombol Lanjut -->
      <button
        class="btn-continue"
        :class="{ 'btn-active': localNickname.length > 0 }"
        :disabled="localNickname.length === 0"
        @click="handleSubmit"
      >
        <span>Lanjutkan</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/>
        </svg>
      </button>

      <!-- Tombol Kembali -->
      <button class="btn-back" @click="$emit('back')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
        </svg>
        Kembali
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const props = defineProps({
  userName: {
    type: String,
    default: ''
  },
  initialNickname: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['next', 'back']);

const localNickname = ref(props.initialNickname || '');
const errorMsg = ref('');
const inputRef = ref(null);

// Ambil nama depan dari nama lengkap
const fullName = computed(() => props.userName || 'Kamu');

onMounted(() => {
  // Auto-focus input saat halaman muncul
  setTimeout(() => inputRef.value?.focus(), 300);
});

function handleSubmit() {
  errorMsg.value = '';

  if (!localNickname.value.trim()) {
    errorMsg.value = 'Nickname tidak boleh kosong.';
    return;
  }
  if (localNickname.value.trim().length < 2) {
    errorMsg.value = 'Nickname minimal 2 karakter ya!';
    return;
  }

  emit('next', localNickname.value.trim());
}
</script>

<style scoped>
.nickname-card {
  background: #ffffff;
  border-radius: 28px;
  padding: 2.5rem;
  width: 100%;
  max-width: 520px;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.12);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.7);
  text-align: center;
  animation: card-in 0.5s cubic-bezier(0.25, 0.8, 0.25, 1) both;
}

@keyframes card-in {
  from { opacity: 0; transform: translateY(24px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0)    scale(1); }
}

/* Dekorasi sudut */
.deco {
  position: absolute;
  width: 160px;
  height: 160px;
  pointer-events: none;
  z-index: 0;
}
.deco--tl { top: -40px; left: -40px; }
.deco--br { bottom: -40px; right: -40px; }

.card-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.abby-mascot {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.abby-img {
  width: 160px;
  object-fit: contain;

  /* animasi naik turun */
  animation: float-abby 3s ease-in-out infinite;

  /* gradient fade */
  -webkit-mask-image: linear-gradient(to bottom, black 90%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 90%, transparent 100%);

  display: block; /* penting supaya animasi lebih stabil */
}

.abby-header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.abby-dialog {
  position: relative;
  background: #ffffff;
  border: 2px solid #26488A;
  border-radius: 16px;
  padding: 16px;
  margin-top: 10px;
  margin-bottom: 20px;

  /* shadow comic style */
  box-shadow: 4px 4px 0 #26488A;

  /* biar rapi */
  display: flex;
  flex-direction: column;
  gap: 6px;
  animation: pop-in 0.4s ease;
}

/* Ekor (border luar) */
.abby-dialog::before {
  content: "";
  position: absolute;
  top: -12px;
  left: 40px; /* posisi horizontal ekor */

  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #26488A;
}

/* Ekor (isi putih) */
.abby-dialog::after {
  content: "";
  position: absolute;
  top: -10px;
  left: 42px;

  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
}

@keyframes pop-in {
  0% {
    transform: scale(0.95);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes float-abby {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px); /* naik */
  }
  100% {
    transform: translateY(0px);
  }
}

@keyframes wave {
  0%,  60%, 100% { transform: rotate(0deg); }
  10%, 30%       { transform: rotate(20deg); }
  20%            { transform: rotate(-8deg); }
  40%            { transform: rotate(10deg); }
}

/* Judul sapaan */
.greeting-title {
  font-size: 2rem;
  font-weight: 800;
  color: #26488A;
  margin: 0 0 0.75rem 0;
  line-height: 1.2;
}

.highlight-name {
  color: #4489C6;
  position: relative;
}

.highlight-name::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #4489C6, #6DD5FA);
  border-radius: 2px;
}

/* Subtitle */
.greeting-subtitle {
  color: #444;
  font-size: 1rem;
  line-height: 1.65;
  margin: 0 0 0.65rem 0;
}

.greeting-subtitle strong {
  color: #26488A;
}

.greeting-hint {
  color: #7f8c8d;
  font-size: 0.85rem;
  line-height: 1.55;
  margin: 0 0 1.75rem 0;
  padding: 0.65rem 1rem;
  background: #f4f8fc;
  border-radius: 12px;
  border-left: 3px solid #4489C6;
  width: 100%;
  text-align: left;
}

/* Input area */
.input-group {
  width: 100%;
  margin-bottom: 1.25rem;
  text-align: left;
}

.input-wrapper {
  display: flex;
  align-items: center;
  background-color: #F2F2F3;
  border: 2px solid #e0e0e0;
  border-radius: 16px;
  padding-left: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05), inset 0 2px 4px -1px rgba(0,0,0,0.04);
}

.input-wrapper:focus-within {
  border-color: #4489C6;
  box-shadow: 0 4px 8px -1px rgba(0,0,0,0.1), inset 0 2px 4px -1px rgba(0,0,0,0.06);
}

.input-wrapper.has-error {
  border-color: #DF654D;
  animation: shake 0.4s;
}

.input-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
}

.input-icon svg {
  width: 18px;
  height: 18px;
  fill: #95a5a6;
}

input[type="text"] {
  width: 100%;
  padding: 14px 10px;
  border: none;
  background: transparent;
  font-size: 1rem;
  font-family: 'Epilogue', sans-serif;
  color: #2c3e50;
  outline: none;
}

input[type="text"]::placeholder {
  color: #bdc3c7;
}

.error-message {
  color: #DF654D;
  font-size: 0.8rem;
  font-weight: 500;
  margin-top: 0.4rem;
  padding-left: 0.5rem;
}

/* Tombol Lanjutkan */
.btn-continue {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.9rem 1.75rem;
  border-radius: 50px;
  font-family: 'Epilogue', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  cursor: not-allowed;
  border: none;
  background: #bdc3c7;
  color: #fff;
  opacity: 0.65;
  transition: all 0.3s ease;
  margin-bottom: 0.85rem;
}

.btn-continue svg {
  width: 12px;
  height: 12px;
  fill: currentColor;
}

.btn-continue.btn-active {
  background: linear-gradient(135deg, #26488A, #4489C6);
  cursor: pointer;
  opacity: 1;
  box-shadow: 0 5px 18px rgba(38, 72, 138, 0.3);
}

.btn-continue.btn-active:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(38, 72, 138, 0.4);
}

.btn-continue.btn-active:active {
  transform: translateY(0);
}

/* Tombol Kembali */
.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.85rem 0.35rem 0.6rem;
  background: transparent;
  border: 1.5px solid #dce9f5;
  border-radius: 50px;
  color: #4489C6;
  font-family: 'Epilogue', sans-serif;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-back svg {
  width: 9px;
  height: 9px;
  fill: currentColor;
  flex-shrink: 0;
}

.btn-back:hover {
  background: #edf4fb;
  border-color: #4489C6;
  color: #26488A;
  transform: translateX(-2px);
}

/* Animasi shake untuk error */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25%       { transform: translateX(-6px); }
  50%       { transform: translateX(6px); }
  75%       { transform: translateX(-6px); }
}

/* Responsive */
@media (max-width: 480px) {
  .nickname-card {
    padding: 1.75rem 1.25rem;
    border-radius: 20px;
  }

  .greeting-title {
    font-size: 1.55rem;
  }

  .greeting-subtitle {
    font-size: 0.9rem;
  }
}
</style>
